import { render, staticRenderFns } from "./Dog-title-badge-comp.vue?vue&type=template&id=2a93772e&scoped=true&"
import script from "./Dog-title-badge-comp.vue?vue&type=script&lang=js&"
export * from "./Dog-title-badge-comp.vue?vue&type=script&lang=js&"
import style0 from "./Dog-title-badge-comp.vue?vue&type=style&index=0&id=2a93772e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a93772e",
  null
  
)

export default component.exports